import { render, staticRenderFns } from "./sorter.vue?vue&type=template&id=96b0c08c&scoped=true&lang=pug&"
import script from "./sorter.vue?vue&type=script&lang=js&"
export * from "./sorter.vue?vue&type=script&lang=js&"
import style0 from "./sorter.vue?vue&type=style&index=0&id=96b0c08c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b0c08c",
  null
  
)

export default component.exports